import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getPlatingDetails } from "../../helpers/http_platings_requests";
import { useQuery } from "@tanstack/react-query";

export default function PlatingDetails() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getPlatingDetails', id], 
        queryFn: () => getPlatingDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: platingData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Banho - Detalhes",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    return <DynamicFormPage 
        isLoading={isFetching} 
        details 
        initialData={platingData} 
        title={"Banho - Detalhes"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
    />;
};
